<!--
 * @Author: your name
 * @Date: 2021-12-07 15:40:36
 * @LastEditTime: 2021-12-14 14:59:11
 * @LastEditors: Please set LastEditors
 * @Description: 新闻动态
 * @FilePath: \new-website-1123\src\views\service\joinus\index.vue
-->
<template>
  <div class="news-details">
    <div class="news-title">上太动态</div>
    <div class="news-connect">
      <h2>{{ newDetails.title }}</h2>
      <div class="news-dynamic"><span>上太动态</span>{{ newDetails.date }}</div>

      <div class="news-article" v-html="newDetails.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-details",
  components: {},
  data() {
    return {
      newDetails: {
        title: "“拖拉机”上天之后，我觉得种地这事儿帅爆了！",
        date: "2021-11-26",
        content:
          '<p>现在提起无人机，俨然在聊一个过气网红。前两年无人机当红的时候，街上被吃瓜群众围住的不是突发车祸，就是拿着遥控器把玩无人机的装逼现场。</p><br /><img src="https://stkjiot.com/resources/news/newsimg4.jpg" style="display:block;margin: 0 auto;" /><br /><p>但是吧，从天上往地下放种子，无风的天还好，遇到有风的时候，这种子得吹到什么地方去？于是他们做了个骚操作，在无人机的播种模块下面加了个能高速喷气的管道，气流速度能达到 18 米/秒，这时候种子就可以像气枪里的子弹一样，直接被气流射到需要播种的地方。</p><br /><img src="https://stkjiot.com/resources/news/newsimg5.jpg" style="display:block;margin: 0 auto;" /><br /><p>总之，这套设备的集成度还是很高的。如果实际效果真的有极飞说的那么好，那将有可能极大程度地降低种植过程中的人力成本。可惜的是，到 2017 年为止，中国已是全球无人机保有量领先的国家了，而农业无人机作业面积却只占到了农业总体作业面积的 5% ，这个比例，在日本是 50% ，在美国是 65% 。。看来大部分买无人机的都是买来玩了。。不过差评君觉得，这事儿也要从两方面来看，美国日本的农业机械化比国内早了很多年，大农场遍布，条件成熟，农业无人机的铺开比较容易，配套设施也方便，而国内人多地少，整个行业想要转型，需要非常夸张的成本。就算有国家补贴，植保无人机的价格也得几万块钱起步，要是再备上几套电池和不同的挂件，成本是绝大多数农民朋友们承受不了的。也就大农场能够比较好地普及类似的设备，更不用说器械本身的学习成本了。但是农业的发展离不开器械的进步，从早期的锄头，犁头，到现在的拖拉机，工具的进步在农业上体现出了极大的优势，早晚有一天，种地只要会开无人机就够了。</p><br /><img src="https://stkjiot.com/resources/news/newsimg6.jpg" style="display:block;margin: 0 auto;" /><br />',
      },
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.news-title {
  font-size: 32px;
  color: $color-active;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-top: 20px;
  width: 1200px;
  margin: 0 auto;
}
.news-connect {
  width: 1200px;
  color: $color-text;
  margin: 0 auto;
  padding: 60px;
  margin-bottom: 80px;
  background: rgba(255, 255, 255, 0.05);
  h2 {
    font-weight: normal;
    font-size: 44px;
    font-family: Microsoft YaHei;
    margin-bottom: 34px;
  }

  .news-article {
    color: rgba(255, 255, 255, 0.8);
    line-height: 30px;
  }
  .news-dynamic {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 60px;
    span {
      display: inline-block;
      font-size: 12px;
      padding: 0 8px;
      background: rgba(22, 22, 22, 0.5);
      color: $color-active;
      height: 24px;
      line-height: 24px;
      text-align: center;
      margin-right: 20px;
    }
  }
}
</style>
